import gql from 'graphql-tag';

/**
 * Mutation to add a section to an inspection template (e.g. restore after removal).
 */
export const addSectionToTemplateMutation = gql`
  mutation AddSectionToTemplate($input: AddSectionToTemplateInput!) {
    addSectionToTemplate(input: $input) {
      success
      newVersion
    }
  }
`;
